var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper_custom_input"},[_c('span',{staticClass:"text new_theme_input_label"},[_vm._v(_vm._s(_vm.text))]),(_vm.star)?_c('span',{staticClass:"star"},[_vm._v("*")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }